import './GlobalHeader.scss';
import { IHeaderProps, IMenuItem } from './types';
import * as React from 'react';
import { connect } from 'react-redux';
import FlexContainer from '../Layout/FlexContainer';
import logoImageSrc from '../../images/Logos/3f-logo.svg';
import lock from 'src/images/lock.svg';
import MediaQuery from 'react-responsive';
import FloatingHeader from '../FloatingHeader';
import NavList from '../NavList';
import SubNav from './SubNav';
import Wrapper from '../Wrapper';
import { usePages, usePageTree } from 'src/context/pages';
import { ActivityThemeSelector } from 'src/Entities/ActivityTheme/ActivityTheme.Selector';

const GlobalHeader = (props: IHeaderProps) => {
  const { fetchList } = usePages();
  const tree = usePageTree();
  const { menuItems, userName, unionName, logOut } = props; // Todo: change to current User if any
   // ToDo: make sure to have a page Not found!
  const activeMenuItem: IMenuItem = menuItems.filter(item => location.pathname.indexOf(item.path) !== -1)[0] !== undefined ? menuItems.filter(item => location.pathname.indexOf(item.path) !== -1)[0] : menuItems[0];

  const subItems: IMenuItem[] = React.useMemo(() => {
    const items: IMenuItem[] = [...activeMenuItem.children];

    const courseItems: IMenuItem[] = props.themes.map((theme) => {
      return {
        path: `/kurser/${theme.themeId}`,
        label: theme.name,
        children: [],
      }
    });
    const courseItem = activeMenuItem.children
      .find((item: IMenuItem) => item.path === '/kurser');

    if (courseItem) {
      items[items.indexOf(courseItem)] = {
        ...courseItem,
        children: courseItems,
      };
    }

    const pageItems = tree.map((treeNode) => {
      return {
        path: `/sider/${treeNode.slug}`,
        label: treeNode.title,
        children: treeNode.children
          ? treeNode.children.map((page) => ({
            path: `/sider/${page.slug}`,
            label: page.title,
            children: [],
          }))
          : []
      };
    });

    if (activeMenuItem) {
      items.splice(2, 0, ...pageItems);
      return items;
    }

    return items;
  }, [activeMenuItem, tree, props.themes]);

  React.useEffect(() => {
    fetchList();
  }, []);

  return (
    <div className="global-header">
      <MediaQuery maxWidth={992}>
        <FloatingHeader {...props} />
      </MediaQuery>
      <MediaQuery minWidth={992}>
        <Wrapper>
        {/* SWAP THE LOGO */}
        <FlexContainer alignItems="center" justifyContent="between">
          <div className="flex items-center">
            <img src={logoImageSrc} className="global-header__logo" alt="logo" />
            <span className="f3 b t1"> Kurser for valgte og ansatte</span>
          </div>
          {userName && (
            <div className="f6 has-text-dark-blue">
              <div>Velkommen</div>
              <div className="flex items-center">

                <span className="b flex-none">{userName}, {unionName}</span>
                <div onClick={logOut} className="cursor-pointer">
                  <img src={lock} width="10" className="ml2 flex-none" />
                </div>
              </div>
            </div>
          )}

        </FlexContainer>
        </Wrapper>
        {/* <div className="global-header__top has-background-blue has-text-white">
          <Wrapper>
            <FlexContainer justifyContent="between" alignItems="center">
              {userName && (
                <strong>
                  Velkommen {userName}, {unionName}
                  <div onClick={() => logOut()} style={{cursor:"pointer", display:"inline-block"}}>
                  <img src={lock} width="8" className="ml2" />

                  </div>
                </strong>
              )}
              <NavList items={menuItems} color="blue" />
            </FlexContainer>
          </Wrapper>
        </div> */}
        <div className="has-background-blue has-text-white">
          <Wrapper>
            <FlexContainer justifyContent="between" alignItems="center">
              <div className="global-header__title">{activeMenuItem.label}</div>
              <SubNav menuItems={subItems} />
            </FlexContainer>
          </Wrapper>
        </div>
      </MediaQuery>
    </div>
  );
}

function mapStateToProps(state: any, ownProps: any) {
  return {
    themes: ActivityThemeSelector.getThemes(),
    counts: ActivityThemeSelector.getRelevantThemeCounts()
  };
}

export default connect(mapStateToProps)(GlobalHeader);



// WEBPACK FOOTER //
// ./src/components/GlobalHeader/index.tsx